<template>
  <div class="chat__head chat-head">
    <div class="chat-head__user" v-if="!title">
      <div>{{ head.title }}</div>
      <PopoverMenu  icon="chat-more-dots-horizontal" class="chat-head__more">
        <a href="#" @click="handleInfoClick">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="5" r="0.5" fill="#003882" stroke="#CCD7E6"/>
            <path d="M8 8V10.6667M4.66667 14H11.3333C12.8061 14 14 12.8061 14 11.3333V4.66667C14 3.19391 12.8061 2 11.3333 2H4.66667C3.19391 2 2 3.19391 2 4.66667V11.3333C2 12.8061 3.19391 14 4.66667 14Z" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('chat.header-info.info') }}
        </a>
        <a v-if="isAdmin" href="#" @click="handleEditClick">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.82175 8.31668L8.50195 2.054C8.8957 1.68486 9.51134 1.69479 9.89299 2.07644L12.9038 5.0872C13.2894 5.47279 13.2949 6.09622 12.9163 6.48865L6.43578 13.2053C5.94579 13.7131 5.27041 14 4.56471 14H1V10.2135C1 9.49482 1.29746 8.80821 1.82175 8.31668Z"
                  stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('chat.header-info.edit') }}
        </a>
        <a v-if="isAdmin" href="#" @click="handleAddMembersClick">
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.46836 8.41056C6.82851 8.41056 8.13295 8.95087 9.09472 9.91264C9.26811 10.086 9.42779 10.2705 9.57309 10.4645C10.6647 11.9218 9.12076 13.539 7.29996 13.539L3.63677 13.539C1.81597 13.539 0.272061 11.9218 1.36364 10.4645C1.50893 10.2705 1.66862 10.086 1.842 9.91264C2.80377 8.95087 4.10821 8.41056 5.46836 8.41056ZM5.46836 8.41056C7.23859 8.41056 8.67363 6.97551 8.67363 5.20528C8.67363 3.43505 7.23857 2 5.46835 2C3.69812 2 2.26307 3.43505 2.26307 5.20528C2.26307 6.97551 3.69814 8.41056 5.46836 8.41056ZM11.8789 7.3574H13.9395M13.9395 7.3574H16M13.9395 7.3574V9.41794M13.9395 7.3574V5.29686" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('chat.header-info.add-users') }}
        </a>
        <a class="chat-head-leave" href="#" @click="handleLeaveClick">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 8.49973V11.9999C13 13.1045 12.1045 14 10.9999 13.9999L3.9999 13.9995C2.89537 13.9995 2 13.1041 2 11.9995V5.00002C2 3.89545 2.89543 3.00002 4 3.00002H7.5" stroke="#C34343" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11 2H14" stroke="#C34343" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 5V2" stroke="#C34343" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 6L14 2" stroke="#C34343" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t('chat.header-info.leave-group') }}
        </a>
      </PopoverMenu>
    </div>
    <div v-else class="chat-head__user"><span>{{ title }}</span></div>
    <div class="chat-head__status" v-if="isGroupChat">
      <span>{{ title || headMembers }}</span>
    </div>
    <div class="chat-head__status" v-else-if="!isGroupChat && !title">
      <span class="chat-head__status-icon" :class="[head.online && 'online']"></span>
      <span v-if="head.online">{{ $t('chat.header-info.online') }}</span>
      <span v-else>{{ $t('chat.header-info.offline') }}</span>
    </div>
    <SvgIcon v-if="!selectedMode" @click.native="close" class="chat-head__close" name="close-gray" />
    <div v-else class="chat-head__select-done" @click="$emit('selectDone')">done</div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { withUi } from '@/components/ui'
import { groupDeleteService } from '@/store/chat/chat-api'

export default {
  components: {},
  mixins: [withUi],
  props: {
    head: Object,
    title: String,
    isAdmin: Boolean,
    selectedMode: Boolean
  },
  computed: {
    isGroupChat() {
      return [1, 3].includes(this.head.type)
    },
    headMembers() {
      const mLength = this.head.members.length
      return `${mLength} ${this.$t('chat.header-info.members')}`
    },
    ...mapGetters('chat', ['headActive']),
  },
  methods: {
    handleInfoClick() {
      this.$emit('changeView', 'info')
    },
    handleLeaveClick() {
      groupDeleteService(this.head.id);
      this.deleteGroup({id: this.head.id})
      this.$emit('changeView', 'main')
    },
    handleAddMembersClick() {
      this.$emit('changeView', 'members')
    },
    handleEditClick() {
      this.$emit('changeView', 'edit')
    },
    close() {
      this.$emit('changeView', 'main')
    },
    ...mapMutations('chat', ['deleteGroup']),
  },
}
</script>

<style lang="scss" scoped>
.chat-head {
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  padding: 16px 10px 8px 24px;
  background: #ffffff;
  border-bottom: 1px solid rgba(180, 187, 198, 0.13);
  text-align: center;
  &__back {
    position: absolute;
    left: 40px;
    top: 24px;
    cursor: pointer;
    color: $dark;
    .svg-icon {
      font-size: 14px;
      transition: transform 0.25s ease-in-out;
      will-change: transform;
    }
    &:hover {
      .svg-icon {
        transform: translate(-6px);
      }
    }
  }
  &__user {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
  }
  &__status {
    display: inline-flex;
    align-items: center;
    color: $dark;
    span {
      margin-left: 6px;
    }
  }
  &__status-icon {
    flex: 0 0 auto;
    display: inline-block;
    min-width: 12px;
    min-height: 12px;
    font-size: 14px;
    line-height: 17px;
    background: $primary;
    border: 2px solid #ffffff;
    border-radius: 50%;
    &.online {
      background: #1ac57e;
    }
  }
  &-leave {
    color: #C34343 !important;
  }
  &__more {
    margin-left: 10px;
    ::v-deep .more__menu {
      right: 0;
      top: 100%;
      width: 175px;
    }
    ::v-deep .more__trigger .svg-icon {
      font-size: 4px;
    }

    svg {
      margin-right: 8px;
    }
  }

  &__close {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  &__select-done {
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer;

    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    color: #003882;
  }
}
</style>
